import React from 'react';
import {withRouter} from "react-router-dom";
import MultipleChoices from "../common/MultipleChoices";

const Checkboxes = (props) => {
  return <MultipleChoices {...props} />
}

export default withRouter(Checkboxes);
